// Project
import { putCaseData } from 'src/lib/fetch';

export const unlockLinking = async (email: string) => {
  const result = await putCaseData(`/blocked-users/${email}`, {});
  return result;
};
